// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: vBcMyVvohcRf6jTAAhLpUM
// Component: 8chwB44Kqzh

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import AppBar from "../../AppBar"; // plasmic-import: ZuLNCCRd3O/component
import JobArtefact from "../../JobArtefact"; // plasmic-import: fti0uXre5Q/component

import { useScreenVariants as useScreenVariantsd6SciKGyMe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: d6sciKGyMe/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_ibeam_access.module.css"; // plasmic-import: vBcMyVvohcRf6jTAAhLpUM/projectcss
import sty from "./PlasmicJobsView.module.css"; // plasmic-import: 8chwB44Kqzh/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: fpDQ9jqu4nZ/icon
import imageGemkdHeh9 from "./images/image.png"; // plasmic-import: GemkdHEH9/picture

export type PlasmicJobsView__VariantMembers = {
  loading: "loading";
};
export type PlasmicJobsView__VariantsArgs = {
  loading?: SingleBooleanChoiceArg<"loading">;
};
type VariantPropType = keyof PlasmicJobsView__VariantsArgs;
export const PlasmicJobsView__VariantProps = new Array<VariantPropType>(
  "loading"
);

export type PlasmicJobsView__ArgsType = {
  avatarIcon?: React.ReactNode;
  ibeamLogo?: React.ReactNode;
  map?: React.ReactNode;
  artefacts?: React.ReactNode;
  jobNumber?: React.ReactNode;
  spinner?: React.ReactNode;
  location?: React.ReactNode;
  time?: React.ReactNode;
  jobDeleteButton?: React.ReactNode;
};
type ArgPropType = keyof PlasmicJobsView__ArgsType;
export const PlasmicJobsView__ArgProps = new Array<ArgPropType>(
  "avatarIcon",
  "ibeamLogo",
  "map",
  "artefacts",
  "jobNumber",
  "spinner",
  "location",
  "time",
  "jobDeleteButton"
);

export type PlasmicJobsView__OverridesType = {
  root?: p.Flex<"div">;
  appBar?: p.Flex<typeof AppBar>;
  artefactsBox?: p.Flex<"div">;
};

export interface DefaultJobsViewProps {
  avatarIcon?: React.ReactNode;
  ibeamLogo?: React.ReactNode;
  map?: React.ReactNode;
  artefacts?: React.ReactNode;
  jobNumber?: React.ReactNode;
  spinner?: React.ReactNode;
  location?: React.ReactNode;
  time?: React.ReactNode;
  jobDeleteButton?: React.ReactNode;
  loading?: SingleBooleanChoiceArg<"loading">;
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicJobsView__RenderFunc(props: {
  variants: PlasmicJobsView__VariantsArgs;
  args: PlasmicJobsView__ArgsType;
  overrides: PlasmicJobsView__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "loading",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.loading
      }
    ],
    [$props, $ctx]
  );
  const $state = p.useDollarState(stateSpecs, { $props, $ctx, $queries });

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsd6SciKGyMe()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root,
            { [sty.rootloading]: hasVariant($state, "loading", "loading") }
          )}
        >
          <AppBar
            data-plasmic-name={"appBar"}
            data-plasmic-override={overrides.appBar}
            avatarIcon={p.renderPlasmicSlot({
              defaultContents: (
                <svg
                  className={classNames(projectcss.all, sty.svg__dGkee)}
                  role={"img"}
                />
              ),

              value: args.avatarIcon
            })}
            className={classNames("__wab_instance", sty.appBar)}
            ibeamLogo={p.renderPlasmicSlot({
              defaultContents: (
                <img
                  alt={""}
                  className={classNames(
                    projectcss.all,
                    projectcss.img,
                    sty.img__joNiu
                  )}
                  src={imageGemkdHeh9}
                />
              ),

              value: args.ibeamLogo
            })}
          />

          {(hasVariant($state, "loading", "loading") ? true : false) ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__wtvI, {
                [sty.freeBoxloading__wtvIgcpuk]: hasVariant(
                  $state,
                  "loading",
                  "loading"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: null,
                value: args.spinner
              })}
            </div>
          ) : null}
          {(hasVariant($state, "loading", "loading") ? true : true) ? (
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__i5YbL, {
                [sty.freeBoxloading__i5YbLgcpuk]: hasVariant(
                  $state,
                  "loading",
                  "loading"
                )
              })}
            >
              <div className={classNames(projectcss.all, sty.freeBox__vopsq)}>
                {true ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__y7Suo)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "JOB -101",
                      value: args.jobNumber,
                      className: classNames(sty.slotTargetJobNumber)
                    })}
                    {p.renderPlasmicSlot({
                      defaultContents: (
                        <IconIcon
                          className={classNames(projectcss.all, sty.svg__p3XMb)}
                          role={"img"}
                        />
                      ),

                      value: args.jobDeleteButton
                    })}
                  </div>
                ) : null}
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__qc5Ao)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: (
                      <React.Fragment>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__fu29
                          )}
                        >
                          {"10:01AM"}
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__st5Wd
                          )}
                        >
                          {"AUG 29"}
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__qPdJn
                          )}
                        >
                          {"2021"}
                        </div>
                      </React.Fragment>
                    ),
                    value: args.time
                  })}
                </p.Stack>
              </div>
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__jZiH)}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox___7NjMp)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: (
                      <React.Fragment>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__fw6Ei
                          )}
                        >
                          {"Churchill Road"}
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__bzhyG
                          )}
                        >
                          {"PROSPECT, SA"}
                        </div>
                      </React.Fragment>
                    ),
                    value: args.location
                  })}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__zr48H)}>
                  {p.renderPlasmicSlot({
                    defaultContents: null,
                    value: args.map
                  })}
                </div>
              </p.Stack>
              <div
                data-plasmic-name={"artefactsBox"}
                data-plasmic-override={overrides.artefactsBox}
                className={classNames(projectcss.all, sty.artefactsBox)}
              >
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__phhL)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__nkGPy)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__vgvLq
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "mobileOnly") ? (
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {"ARTEFACT"}
                          </span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {"ARTEFACTS"}
                          </span>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___5AprN)}
                  />

                  <div
                    className={classNames(projectcss.all, sty.freeBox__qD86)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__x3Fnc
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "mobileOnly") ? (
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {""}
                          </span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {""}
                          </span>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </p.Stack>
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <JobArtefact
                      className={classNames(
                        "__wab_instance",
                        sty.jobArtefact__j6Cyb
                      )}
                    />
                  ),

                  value: args.artefacts
                })}
              </div>
            </p.Stack>
          ) : null}
        </p.Stack>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "appBar", "artefactsBox"],
  appBar: ["appBar"],
  artefactsBox: ["artefactsBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  appBar: typeof AppBar;
  artefactsBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicJobsView__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicJobsView__VariantsArgs;
    args?: PlasmicJobsView__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicJobsView__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicJobsView__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicJobsView__ArgProps,
          internalVariantPropNames: PlasmicJobsView__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicJobsView__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicJobsView";
  } else {
    func.displayName = `PlasmicJobsView.${nodeName}`;
  }
  return func;
}

export const PlasmicJobsView = Object.assign(
  // Top-level PlasmicJobsView renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    appBar: makeNodeComponent("appBar"),
    artefactsBox: makeNodeComponent("artefactsBox"),

    // Metadata about props expected for PlasmicJobsView
    internalVariantProps: PlasmicJobsView__VariantProps,
    internalArgProps: PlasmicJobsView__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicJobsView;
/* prettier-ignore-end */
